import css from './NavigationItem.module.css';
import { useNavigate } from 'react-router-dom';
import { NavItem } from '../../../types/appModels';
import { useContext, useState } from 'react';
import { UserContext } from '../../../context/userContext';
import EmailClientModal from '../EmailClientModal/EmailClientModal';

type NavigationItemProps = {
  navItem: NavItem;
  secondaryClass?: string;
};

const NavigationItem = ({ navItem, secondaryClass }: NavigationItemProps) => {
  const nav = useNavigate();
  const { logout, checkRole } = useContext(UserContext);
  const [showEmailModal, setShowEmailModal] = useState(false);

  const itemClickHandler = async () => {
    if (navItem.type === 'logout') {
      try {
        await logout!();
        window.location.reload();
      } catch (error) {
        alert(error);
      }
    } else if (navItem.type === 'admin') {
      if (checkRole && (checkRole('Admin') || checkRole('atlas.admin'))) {
        nav('/admin');
      } else {
        alert('You do not have permission to access this section.');
      }
    } else if (navItem.type === 'support') {
      setShowEmailModal(true);
    } else if (navItem.type === 'userguide') {
      window.open('http://atlas-user-guide-web-files.s3-website-us-east-1.amazonaws.com/index.html', '_blank');
    } else {
      nav(navItem.value);
    }
  };

  let cssClass = css.navItem;
  if (secondaryClass !== undefined) {
    cssClass += ` ${secondaryClass}`;
  }

  // Add conditional class based on navItem type for different color schemes
  if (navItem.type) {
    cssClass += ` ${css[navItem.type]}`;
  }

  return (
    <>
      <div className={cssClass} onClick={itemClickHandler}>
        <div className={css.labelContainer}>
          {navItem.label.split(' ').map((word, index) => (
            <span key={index}>{word}</span>
          ))}
        </div>
      </div>
      
      {showEmailModal && (
        <EmailClientModal
          onCancel={() => setShowEmailModal(false)}
          emailAddress="Atlas.Support@libertyenergy.com"
        />
      )}
    </>
  );
};

export default NavigationItem;